<app-detail-template>
  <div class="header-margin" container-header>
    <member-chase-detail-header></member-chase-detail-header>
  </div>
  <div container-body>
    <router-outlet></router-outlet>
  </div>
</app-detail-template>